import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00adeec0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "notification is-warning"
}
const _hoisted_2 = {
  key: 1,
  class: "notification is-warning"
}
const _hoisted_3 = {
  key: 2,
  class: "notification is-warning"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Based on ")
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "ml-1" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" of project ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Dataset", -1))
const _hoisted_9 = { class: "field has-addons" }
const _hoisted_10 = { class: "control is-expanded" }
const _hoisted_11 = {
  key: 0,
  disabled: ""
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "No available dataset", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select a dataset", -1))
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "control" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Select child elements recursively", -1))
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "control is-expanded" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "switchRecursive" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Select top-level elements only", -1))
const _hoisted_24 = { class: "field" }
const _hoisted_25 = { class: "control is-expanded" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "switchTopLevel" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Filter by element types", -1))
const _hoisted_29 = { class: "field" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = ["value"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Number of elements", -1))
const _hoisted_34 = { class: "field" }
const _hoisted_35 = { class: "control" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Distribution per set", -1))
const _hoisted_38 = {
  key: 2,
  class: "notification is-warning"
}
const _hoisted_39 = { class: "control mb-4" }
const _hoisted_40 = { class: "multi-progress" }
const _hoisted_41 = ["data-tooltip"]
const _hoisted_42 = { class: "control" }
const _hoisted_43 = { class: "control" }
const _hoisted_44 = ["onUpdate:modelValue", "disabled"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "control" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input is-light is-focused" }, "%")
], -1))
const _hoisted_46 = { class: "control is-expanded" }
const _hoisted_47 = ["onUpdate:modelValue", "disabled"]
const _hoisted_48 = {
  key: 0,
  class: "notification is-warning"
}
const _hoisted_49 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DatasetCreate = _resolveComponent("DatasetCreate")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _ctx.updateModal,
    title: "Populate dataset",
    "is-large": ""
  }, {
    footer: _withCtx(({ close }) => [
      _createElementVNode("button", {
        class: "button",
        onClick: close
      }, "Cancel", 8, _hoisted_49),
      _createElementVNode("button", {
        type: "submit",
        form: "populateFormId",
        class: _normalizeClass(["button is-primary", { 'is-loading': _ctx.loading }])
      }, " Populate ", 2)
    ]),
    default: _withCtx(() => [
      (_ctx.loaded && !_ctx.corpus?.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Corpus is not found. "))
        : (_ctx.loadedParent && _ctx.parentId && !_ctx.parent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Parent element is not found. "))
          : (!_ctx.hasContribPrivilege)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " You must have a contributor access in order to perform this action. "))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("h2", null, [
                  _hoisted_4,
                  (_ctx.parent)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", {
                          class: "is-capitalized",
                          title: _ctx.parent.type
                        }, _toDisplayString(_ctx.truncateLong(_ctx.typeName(_ctx.parent.type))), 9, _hoisted_5),
                        _createVNode(_component_router_link, {
                          to: { name: 'element-details', params: { id: _ctx.parent.id } }
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.truncateLong(_ctx.parent.name)), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]),
                        _hoisted_7
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.corpus?.id)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        to: { name: 'navigation', params: { corpusId: _ctx.corpusId } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.corpus.name), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.corpus)
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 0,
                      id: "populateFormId",
                      onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
                    }, [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["select is-fullwidth", { 'is-danger': _ctx.fieldErrors.dataset }])
                          }, [
                            (_ctx.availableDatasets.length === 0)
                              ? (_openBlock(), _createElementBlock("select", _hoisted_11, _hoisted_13))
                              : _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 1,
                                  required: "",
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDatasetId) = $event)),
                                  class: _normalizeClass({ 'is-danger': _ctx.fieldErrors.top_level_type }),
                                  disabled: _ctx.loading || undefined
                                }, [
                                  _hoisted_15,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableDatasets, (d) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: d.id,
                                      value: d.id
                                    }, _toDisplayString(d.name), 9, _hoisted_16))
                                  }), 128))
                                ], 10, _hoisted_14)), [
                                  [_vModelSelect, _ctx.selectedDatasetId]
                                ])
                          ], 2),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.fieldErrors.dataset ?? []), (err, i) => {
                            return (_openBlock(), _createElementBlock("p", {
                              class: "help is-danger",
                              key: i
                            }, _toDisplayString(err), 1))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "button is-success",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.datasetModal = true)),
                            title: "Create a new dataset"
                          }, " Create ")
                        ])
                      ]),
                      (_ctx.parentId)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_18,
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _withDirectives(_createElementVNode("input", {
                                  id: "switchRecursive",
                                  type: "checkbox",
                                  class: _normalizeClass(["switch is-rtl is-rounded is-info", { 'is-danger': _ctx.fieldErrors.recursive }]),
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.recursive) = $event)),
                                  disabled: _ctx.loading || undefined
                                }, null, 10, _hoisted_21), [
                                  [_vModelCheckbox, _ctx.recursive]
                                ]),
                                _hoisted_22
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.fieldErrors.recursive ?? []), (err, i) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  class: "help is-danger",
                                  key: i
                                }, _toDisplayString(err), 1))
                              }), 128))
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_23,
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _withDirectives(_createElementVNode("input", {
                                  id: "switchTopLevel",
                                  type: "checkbox",
                                  class: _normalizeClass(["switch is-rtl is-rounded is-info", { 'is-danger': _ctx.fieldErrors.recursive }]),
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.topLevel) = $event)),
                                  disabled: _ctx.loading || undefined
                                }, null, 10, _hoisted_26), [
                                  [_vModelCheckbox, _ctx.topLevel]
                                ]),
                                _hoisted_27
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.fieldErrors.recursive ?? []), (err, i) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  class: "help is-danger",
                                  key: i
                                }, _toDisplayString(err), 1))
                              }), 128))
                            ])
                          ], 64)),
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["select is-multiple", { 'is-danger': _ctx.fieldErrors.types }])
                        }, [
                          _withDirectives(_createElementVNode("select", {
                            multiple: "",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.types) = $event)),
                            size: "5",
                            required: "",
                            class: _normalizeClass(["is-fullwidth", { 'is-danger': _ctx.fieldErrors.types }]),
                            disabled: _ctx.loading || undefined
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.corpus.types, (t) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: t.slug,
                                value: t.slug
                              }, _toDisplayString(t.display_name), 9, _hoisted_31))
                            }), 128))
                          ], 10, _hoisted_30), [
                            [_vModelSelect, _ctx.types]
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "button",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.selectAllTypes && _ctx.selectAllTypes(...args))),
                            disabled: _ctx.loading || undefined
                          }, " Select all types ", 8, _hoisted_32)
                        ], 2),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.fieldErrors.types ?? []), (err, i) => {
                          return (_openBlock(), _createElementBlock("p", {
                            class: "help is-danger",
                            key: i
                          }, _toDisplayString(err), 1))
                        }), 128))
                      ]),
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.count) = $event)),
                            type: "number",
                            min: "1",
                            class: _normalizeClass(["input", { 'is-danger': _ctx.fieldErrors.count }]),
                            disabled: _ctx.loading || undefined
                          }, null, 10, _hoisted_36), [
                            [
                              _vModelText,
                              _ctx.count,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.fieldErrors.count ?? []), (err, i) => {
                          return (_openBlock(), _createElementBlock("p", {
                            class: "help is-danger",
                            key: i
                          }, _toDisplayString(err), 1))
                        }), 128))
                      ]),
                      _hoisted_37,
                      (!_ctx.dataset)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, "Please select a dataset first"))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedSets, ({ name }, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: name,
                                    style: _normalizeStyle({ width: `${_ctx.setPercentages[name]}%` }),
                                    class: _normalizeClass(["progress-block has-tooltip-top", _ctx.datasetColors[i % _ctx.datasetColors.length]]),
                                    "data-tooltip": `${name}: ${_ctx.setPercentages[name]}%`
                                  }, null, 14, _hoisted_41))
                                }), 128))
                              ])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedSets, (set, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: set.id,
                                class: "field has-addons"
                              }, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["input is-focused", _ctx.datasetColors[i % _ctx.datasetColors.length]])
                                  }, _toDisplayString(set.name), 3)
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: _normalizeClass(["input", { 'is-danger': _ctx.fieldErrors.sets }]),
                                    type: "number",
                                    required: "",
                                    min: "0",
                                    max: "100",
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.setPercentages[set.name]) = $event),
                                    step: "1",
                                    disabled: _ctx.loading || undefined
                                  }, null, 10, _hoisted_44), [
                                    [
                                      _vModelText,
                                      _ctx.setPercentages[set.name],
                                      void 0,
                                      { number: true }
                                    ]
                                  ])
                                ]),
                                _hoisted_45,
                                _createElementVNode("div", _hoisted_46, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "input",
                                    type: "range",
                                    min: "0",
                                    max: "100",
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.setPercentages[set.name]) = $event),
                                    step: "1",
                                    tabindex: "-1",
                                    disabled: _ctx.loading || undefined
                                  }, null, 8, _hoisted_47), [
                                    [
                                      _vModelText,
                                      _ctx.setPercentages[set.name],
                                      void 0,
                                      { number: true }
                                    ]
                                  ])
                                ])
                              ]))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.fieldErrors.sets ?? []), (err, i) => {
                              return (_openBlock(), _createElementBlock("p", {
                                class: "help is-danger",
                                key: i
                              }, _toDisplayString(err), 1))
                            }), 128)),
                            (!_ctx.validRatio)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_48, " The sum of all ratios must be 100% "))
                              : _createCommentVNode("", true)
                          ], 64))
                    ], 32))
                  : _createCommentVNode("", true)
              ], 64)),
      _createVNode(_component_DatasetCreate, {
        modelValue: _ctx.datasetModal,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.datasetModal) = $event)),
        "corpus-id": _ctx.corpusId,
        onDatasetAction: _ctx.selectDataset
      }, null, 8, ["modelValue", "corpus-id", "onDatasetAction"])
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"]))
}